// extracted by mini-css-extract-plugin
module.exports = {"container":"Stat_container__8r5cH","value":"Stat_value__7yluT","label":"Stat_label__weA3f"};